import React from 'react'
import { Card, Container } from 'react-bootstrap'

interface LoadingViewProps {
  message: string
}

export const LoadingView = (props: LoadingViewProps) => {
  const { message } = props

  return (
    <Container>
      <Card>
        <Card.Header>{message}</Card.Header>
        <Card.Body>loading...</Card.Body>
      </Card>
    </Container>
  )
}
